import { Wording } from '@/types';

export const COOKING_WORDING_DE: Wording = {
  components_header_media_content: 'Kochvideos',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Rezepte',
  components_header_text2: 'Blog',
  components_header_members: 'Mitglieder',
  hero_text: 'Mit Leidenschaft kochen, mit Freude essen',
  hero_button_text: 'Fang noch heute mit dem Kochen an!',
  components_ressources_section_title: 'RESSOURCEN',
  components_ressources_subheader_text: 'Alle Ressourcen, die Sie benötigen, um zu lernen, zu kochen und besseres Essen zuzubereiten',
  components_ressources_span_text: 'Entdecken Sie eine umfangreiche Sammlung von Videorezepten, detaillierten Kochanleitungen und Expertentipps zu Geschmackskombinationen, Speisenpräsentation und kulinarischer Kreativität.',
  components_ressources_card_1_title: 'Kochinspiration',
  components_ressources_card_1_text: 'Lassen Sie sich von kreativen Rezepten und Kochvideos inspirieren.',
  components_ressources_card_2_title: 'Kochkenntnisse',
  components_ressources_card_2_text: 'Lernen Sie mithilfe klarer, praktischer Anleitungen essentielle Kochtechniken, Geschmackskombinationen und die Grundlagen der Speisenbegleitung kennen.',
  components_ressources_link: 'Videos ansehen',
  components_notes_and_google_title_1: 'Kochausbildung',
  components_notes_and_google_title_2: 'Alltagsküche',
  components_notes_and_google_title_3: 'Konstante Kochkenntnisse',
  components_review_google_text: 'Rezensionen auf Google',
  media_content_section_title: 'Kochvideos',
  media_content_section_subheader_text: 'Entdecke Rezepte und Schritt-für-Schritt-Kochvideos.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Weitere Videos',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Leitfäden & Artikel',
  text2_section_button_more: 'Weitere Artikel',
  components_text1_section_title: 'REZEPTE',
  components_text1_subheader_text: 'Leckere Rezepte für die Alltagsküche',
  components_text1_span_text: 'Entdecken Sie leicht verständliche Rezepte für den Alltag, klare Schritt-für-Schritt-Anleitungen und großartige Ergebnisse.',
  components_text1_card_1_title: 'Beginne deinen Tag richtig',
  components_text1_card_1_text: 'Einfache und leckere Rezepte für einen entspannten und genussvollen Start in den Tag.',
  components_text1_card_3_title: 'Geschmackvolle Mittagessen-Ideen',
  components_text1_card_3_text: 'Köstliche Mittagsrezepte, die einfach zuzubereiten sind und voller Geschmack stecken.',
  components_text1_card_2_title: 'Wohltuende Abendessenrezepte',
  components_text1_card_2_text: 'Warme, sättigende Abendessenrezepte, perfekt für entspannte Abende zu Hause.',
  components_text1_link: 'Alle Rezepte ansehen',
  components_footer_text: 'Besser kochen lernen, besseres Essen zubereiten: Ihre Küche, Ihre Reise.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registrierungsnummer',
  components_footer_legal: 'Recht',
  components_footer_terms: 'Geschäftsbedingungen',
  components_footer_privacy: 'Datenschutzrichtlinie',
  button_load_more: 'Mehr laden',
  page_media_1_content_hero_text: 'Entdecken Sie einfache Kochvideos für jeden Geschmack',
  page_text1_hero_text: 'Rezepte',
  page_text1_section_title: 'Kochtipps',
  page_text1_subheader_text: 'Rezepte',
  page_text2_hero_text: 'Unser Blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Leitfäden & Artikel',
  enter_email_title: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um fortzufahren.',
  enter_email_placeholder_email: 'E-Mail',
  enter_email_button_enter: 'Eingeben',
  components_login_success_text: 'Anmeldung erfolgreich!',
  components_card_link_media_content: 'Jetzt ansehen',
  components_card_link_text1_content: 'Rezept ansehen',
  components_card_link_text2_content: 'Artikel ansehen',
};